import { useMemo } from 'react';
import { CounselingService } from '@/services/counseling';
import { useRequiredSession } from '../state/session';

export function useService(): CounselingService {
  const session = useRequiredSession();
  return useMemo(() => new CounselingService(session.repo, session.ctx), [session]);
}
